// Shared "Playful Frost" checkbox glyph — the exact glass box + teal tick used by
// InputGroup type="checkbox" (the .ig-cbx-* classes, globally injected). Use it for
// every interactive checkbox toggle in the app so they all look identical. This is
// render-only: the caller owns the click (usually on a surrounding labelled row).
interface CheckBoxGlyphProps {
  checked?: boolean;
  // Extra class for caller-side sizing overrides (e.g. a 48px status glyph).
  className?: string;
  // Tick svg size in px; the default matches the 22px .ig-cbx-box.
  tickSize?: number;
  // Non-interactive status mark (a done/valid ✓, not a toggle): no pointer cursor.
  decorative?: boolean;
}

const CheckBoxGlyph = ({
  checked,
  className,
  tickSize = 11,
  decorative,
}: CheckBoxGlyphProps) => (
  <span
    className={`ig-cbx-box ${checked ? "ig-cbx-on" : ""}${
      className ? ` ${className}` : ""
    }`}
    style={decorative ? { cursor: "default" } : undefined}
  >
    {checked ? (
      <span className="ig-cbx-check">
        <svg viewBox="0 0 14 14" width={tickSize} height={tickSize}>
          <path
            d="M2 7.2l3 3 7-7.2"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.4}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    ) : null}
  </span>
);

export default CheckBoxGlyph;
